import React from 'react';
import classNames from 'classnames';
import {VideoPlayer} from "../videoPlayer/videoPlayer";

export class YtVideo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		let style = {};
		if(this.props.hideIfInactive && !this.props.item.active) {
			style.display = 'none';
		}

		return (
			<div>
				<div className={classNames({'element--image-gallery--image': true, 'active': this.props.item.active})}>
					<div style={style} title={this.props.item.alt}>
						<img className="video-image-enlargement-helper" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAu4AAAABCAYAAACBkCu0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gcZCgsM77zEGgAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAAHElEQVRIx+3BMQEAAAjAIO0fetbwALYaAADgtwMbWgL/UJ6lpQAAAABJRU5ErkJggg==" />
						<VideoPlayer
							videoUrl={this.props.item.url}
							imageUrl={this.props.item.thumb}
							playable={this.props.item.active}
						/>
					</div>
				</div>
			</div>
		)
	}
}
